import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { uuidSerializer } from "@megaron/uuid";

export const pinnedLinkLimit = 5;
export const pinnedLinkNameMaxLength = 256;
export const pinnedLinkUriMaxLength = 4096;

export const pinnedLinkSerializer = Serializers.object({
  id: uuidSerializer,
  uri: Serializers.string,
  name: Serializers.string,
  pinnedAt: Serializers.datetime,
});

export type PinnedLink = SerializerValue<typeof pinnedLinkSerializer>;

const savePinnedLinkErrorSerializer = Serializers.stringOneOf(
  "PinLimitReached",
  "NameEmpty",
  "UriEmpty",
  "NameTooLong",
  "UriTooLong",
);

export type SavePinnedLinkError = SerializerValue<typeof savePinnedLinkErrorSerializer>;

export const pinnedLinkActions = {
  getPinnedLinks: HttpAction({
    path: "/pinnedLinks",
    method: "get",
    requiresAuth: true,
    valueSerializer: pinnedLinkSerializer.array(),
  }),

  savePinnedLink: HttpAction({
    path: "/pinnedLinks",
    method: "put",
    requiresAuth: true,
    bodySerializer: Serializers.object({
      id: uuidSerializer,
      uri: Serializers.string,
      name: Serializers.string,
    }),
    errorSerializer: savePinnedLinkErrorSerializer,
  }),

  deletePinnedLink: HttpAction({
    path: "/pinnedLinks/:id",
    method: "delete",
    requiresAuth: true,
    paramsSerializer: Serializers.object({ id: uuidSerializer }),
  }),
};
